import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { comics, categories } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryComics = comics.filter((c) => c.category === category?.name);

  if (!category) {
    return (
      <div className="min-h-screen bg-stone-50">
        <Navbar />
        <div className="pt-24 pb-20 text-center">
          <h1 className="text-2xl font-[family-name:var(--font-heading)] text-stone-800">分类未找到</h1>
          <Link to="/" className="mt-4 inline-block text-sm text-stone-500 hover:text-stone-800">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${category.name} - 韩漫屋韩国漫画分类`,
            description: `韩漫屋${category.name}分类，收录${category.count}+部精选韩国漫画，免费在线观看。`,
            url: 'http://98fire.com/category/all',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫屋',
              url: 'http://98fire.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://98fire.com/' },
                { '@type': 'ListItem', position: 2, name: category.name, item: 'http://98fire.com/category/all' },
              ],
            },
          }),
        }}
      />
      <div className="min-h-screen bg-stone-50">
        <Navbar />
        <main className="pt-24 pb-20">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10">
            <nav className="flex items-center gap-2 text-xs text-stone-400 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-stone-600 transition-colors">首页</Link>
              <span>/</span>
              <span className="text-stone-600">{category.name}</span>
            </nav>

            <div className="flex items-center gap-4 mb-10">
              <div className="w-14 h-14 rounded-2xl bg-stone-200 flex items-center justify-center">
                <i className={`${category.icon} text-2xl text-stone-600`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold font-[family-name:var(--font-heading)] text-stone-800">
                  {category.name}
                </h1>
                <p className="text-sm text-stone-400 mt-1">共 {category.count}+ 部作品</p>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-10">
              <div className="flex-1">
                {categoryComics.length > 0 ? (
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                    {categoryComics.map((comic) => (
                      <Link
                        key={comic.id}
                        to={`/comic/${comic.slug}`}
                        className="group cursor-pointer"
                        data-product-shop=""
                      >
                        <div className="relative overflow-hidden rounded-xl bg-stone-100 mb-3 aspect-[3/4]">
                          <img
                            src={comic.cover}
                            alt={comic.title}
                            title={comic.title + ' - 韩漫屋韩国漫画'}
                            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                            loading="lazy"
                          />
                          <div className="absolute top-3 right-3">
                            <span className="flex items-center gap-0.5 px-2 py-1 bg-black/60 backdrop-blur-sm rounded-full text-[10px] font-medium text-white whitespace-nowrap">
                              <i className="ri-star-fill text-yellow-400 text-[10px]"></i> {comic.rating}
                            </span>
                          </div>
                        </div>
                        <h3 className="text-sm font-medium text-stone-800 group-hover:text-stone-600 transition-colors line-clamp-1">
                          {comic.title}
                        </h3>
                        <p className="mt-1 text-xs text-stone-400">
                          {comic.latestChapter} · {comic.author}
                        </p>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-20">
                    <p className="text-stone-400 text-sm">该分类暂无漫画，敬请期待</p>
                  </div>
                )}
              </div>

              <div className="lg:w-[240px] flex-shrink-0">
                <div className="sticky top-24">
                  <h3 className="text-sm font-medium text-stone-800 mb-4">全部分类</h3>
                  <div className="space-y-1">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to="/category/all"
                        className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                          cat.slug === slug
                            ? 'bg-stone-200/70 text-stone-800 font-medium'
                            : 'text-stone-500 hover:bg-stone-100 hover:text-stone-700'
                        }`}
                      >
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-xs`}></i>
                        </div>
                        <span className="flex-1">{cat.name}</span>
                        <span className="text-xs text-stone-400">{cat.count}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}